var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "billing" },
    [
      _c("CurrentPlans"),
      _vm._v(" "),
      _c("Plans"),
      _vm._v(" "),
      _c("FeaturePlans"),
      _vm._v(" "),
      _c("PaymentMethod"),
      _vm._v(" "),
      _c("Invoices"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }